<form [formGroup]="formGroupRef">
  <div class="form-section">
    <div class="form-section-content" style="width: 80%">
      <div class="mt-2">
        <div class="flex flex-wrap-responsive">
          <div class="flex">
            <mat-form-field class="mr-2">
              <mat-label>First Name</mat-label>
              <input matInput type="text" formControlName="firstName">
            </mat-form-field>
          </div>
          <div class="flex">
            <mat-form-field class="mr-2">
              <mat-label>Last Name</mat-label>
              <input matInput type="text" formControlName="lastName">
            </mat-form-field>
          </div>
          <div class="flex">
            <mat-form-field class="mr-2">
              <mat-label>Email</mat-label>
              <input matInput type="text" formControlName="email">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <div class="flex">
          <mat-form-field class="mr-2" style="width: 100%">
            <mat-label>Subject</mat-label>
            <input matInput type="text" formControlName="subject">
          </mat-form-field>
        </div>
      </div>
      <div class="mt-2">
        <div class="flex">
          <mat-form-field class="mr-2" style="width: 100%">
            <mat-label>Description</mat-label>
            <textarea
              #autosize="cdkTextareaAutosize"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="5"
              cdkAutosizeMaxRows="5"
              formControlName="description">
              </textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
